import React from 'react';
import service1 from '../../../Assets/service1.svg';
import service2 from '../../../Assets/service2.svg';
import service3 from '../../../Assets/service3.svg';
import service4 from '../../../Assets/service4.svg';
import chevron from '../../../Assets/Chevron-Right.svg';
import './Services.css';

const Services = () => {
    return (
        <div className="container pt-3">
                <div className='row d-flex align-items-start justify-content-between p-md-5'>
                    <div className="col-md-5 col-12 service-content d-flex align-content-around flex-wrap px-md-5">
                            <h1 className='theme-font'>Our services turn your vision into reality</h1>
                            <h5 style={{ textAlign: 'justify' }}>We are here in the search of creativity.Whatever talent you have we are here to help you. Do what you want, do what you love.We are dealing in various Domain, choose what you fit in.</h5>

                            <div>
                                <button style={{ color: '#ffec02' }} className='btn btn-dark btn-service rounded-0'> View All </button>
                                <button style={{ backgroundColor: 'black' }} className='btn btn-service  rounded-0'><img src={chevron} alt="" /></button>
                            </div>
                    </div>
                    <div className="col-md-7 p-5">
                        <div className="row g-md-5 g-3">
                            <div className="col-md-6 d-flex flex-column py-4">
                                <div className="card border-0 p-2 mb-5">
                                    <img src={service1} className="card-img-top w-25 h-25" alt="..." />
                                    <div className="card-body">
                                        <h5 className="card-title">Design &amp; Development</h5>
                                        <p style={{ textAlign: 'justify' }}>We are here in the search of creativity.Whatever talent you have we are here to help you.</p>
                                        <p> <b>Read More &gt;&gt;</b> </p>
                                    </div>
                                </div>
                                <div className="card border-0 p-2">
                                    <img src={service3} className="card-img-top w-25 h-25" alt="..." />
                                    <div className="card-body">
                                        <h5 className="card-title">Travel &amp; Explore</h5>
                                        <p style={{ textAlign: 'justify' }}>We are here in the search of creativity.Whatever talent you have we are here to help you.</p>
                                        <p> <b>Read More &gt;&gt;</b> </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex flex-column">
                                <div className="card border-0 p-2 mb-5">
                                    <img src={service2} className="card-img-top w-25 h-25" alt="..." />
                                    <div className="card-body">
                                        <h5 className="card-title">Social Media Marketing</h5>
                                        <p style={{ textAlign: 'justify' }}>We are here in the search of creativity.Whatever talent you have we are here to help you.</p>
                                        <p> <b>Read More &gt;&gt;</b> </p>
                                    </div>
                                </div>
                                <div className="card border-0 p-2">
                                    <img src={service4} className="card-img-top w-25 h-25" alt="..." />
                                    <div className="card-body">
                                        <h5 className="card-title">Social Media Marketing</h5>
                                        <p style={{ textAlign: 'justify' }}>We are here in the search of creativity.Whatever talent you have we are here to help you.</p>
                                        <p> <b>Read More &gt;&gt;</b> </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default Services;